module.exports = __webpack_public_path__ + "img/coctail-3.0cad78b1.png";